class cartDiscountsApplier extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		//
		this.input = this.querySelector('input');
		this.applyDiscountsBtn = this.querySelector('button');
		this.loadingSpinner = this.applyDiscountsBtn.querySelector('.loading__spinner');
		this.applyDiscountsBtn.addEventListener('click', this.applyDiscounts.bind(this));
		this.discountCode = '';
		document.addEventListener('discounts:showMessage', (event) => {
			this.showMessage(event.detail?.isSuccess);
		});

		// this.deleteCartCookieBtn = this.querySelector('#deleteCartCookie');
		// this.deleteCartCookieBtn.addEventListener('click', this.deleteCartCookie.bind(this));
		this.selectors = {
			errorMessage: '#errorMessage',
			successMessage: '#successMessage',
		};
		this.errorMessage = this.querySelector(this.selectors.errorMessage);
		this.successMessage = this.querySelector(this.selectors.successMessage);
		this.checkIfInputIsTyping();
	}

	fetchCheckout() {
		// Fetch checkout
		if (!this.discountCode) {
			return;
		}
		let discountApplyUrl = Shopify.routes.root + 'checkout?discount=' + this.discountCode + '&skip_shop_pay=true';
		this.setButtonLoading();
		// console.log('Fetching checkout');
		fetch(discountApplyUrl)
			.then((response) => response.text())
			.then((data) => {
				console.log('Success:', data);
				this.refreshCart();
				this.resetButtonLoading();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	}

	applyDiscounts() {
		// Apply discounts
		this.extractDiscounts();
		this.fetchCheckout();
	}

	setButtonLoading() {
		// Set button loading
		this.applyDiscountsBtn.disabled = true;
		this.applyDiscountsBtn.setAttribute('aria-busy', true);
		this.loadingSpinner.classList.remove('hidden');
	}

	resetButtonLoading() {
		// Button loader
		// Change attributes disabled and aria-busy
		this.applyDiscountsBtn.disabled = false;
		this.applyDiscountsBtn.setAttribute('aria-busy', false);
		this.loadingSpinner.classList.add('hidden');
	}

	refreshCart() {
		// Refresh cart
		document.dispatchEvent(
			new CustomEvent('discounts:apply', {
				detail: {
					discountCode: this.discountCode,
				},
				bubbles: true,
			}),
		);
	}

	showMessage(isSuccess) {
		this.errorMessage.classList.add('hide');
		this.successMessage.classList.add('hide');
		if (isSuccess) {
			this.showSuccessMessage();
		} else {
			this.showErrorMessage();
		}
	}

	extractErrors(response) {
		// Extract errors
		// console.log('Extracting errors');
		// console.log('Response:', response);
		// html id with error in the id name
		// DISCOUNTS_CURRENTLY_INACTIVE
		let reg = ['DISCOUNTS_CURRENTLY_INACTIVE', 'DISCOUNTS_NOT_FOUND', 'DISCOUNTS_NO_ENTITLED_LINE_ITEMS'];
		reg = new RegExp(reg.join('|'), 'i');
		// console.log('Reg:', reg);
		let match = response.match(reg);
		// console.log('Match:', match);
		if (match) {
			this.showErrorMessage();
			return false;
		} else {
			console.log('No error found');
			return true;
		}
	}

	showSuccessMessage() {
		// Show success message
		// console.log('Showing success message');
		// this.successMessage.innerHTML = message;
		// Show success message just for 5 seconds
		const message = document.querySelector(this.selectors.successMessage);
		// console.log('Message:', message);
		message.classList.remove('hide');
	}

	showErrorMessage() {
		// Show error message
		// console.log('Showing error message');
		// this.errorMessage.innerHTML = message;
		// Show error message just for 5 seconds
		this.errorMessage.classList.remove('hide');
	}

	extractDiscounts() {
		// Extract discounts
		// console.log('Extracting discounts');
		this.discountCode = this.input.value;
	}

	_findErrorInJSON(obj) {
		if (obj.hasOwnProperty('errors')) {
			return obj.errors;
		}
		for (let key in obj) {
			if (typeof obj[key] === 'object' && obj[key] !== null) {
				let found = this._findErrorInJSON(obj[key]);
				if (found) {
					return found;
				}
			}
		}
	}

	setButtonActive() {
		// Set button active
		// console.log('Setting button active');
		this.applyDiscountsBtn.removeAttribute('disabled');
	}

	setButtonInactive() {
		// Set button inactive
		// console.log('Setting button inactive');
		this.applyDiscountsBtn.setAttribute('disabled', true);
	}

	checkIfInputIsEmpty() {
		// Check if input is empty
		// console.log('Checking if input is empty');
		if (this.input.value === '') {
			this.setButtonInactive();
		} else {
			this.setButtonActive();
		}
	}

	checkIfInputIsTyping() {
		// Check if input is typing
		// console.log('Checking if input is typing');
		this.input.addEventListener('input', () => {
			// console.log('Input is typing');
			this.checkIfInputIsEmpty();
		});
	}

	deleteCartCookie() {
		// Delete cart cookie
		console.log('Deleting cart cookie');

		// First fetch cart get all item variant ids and quantities then remove cart cookie and then add items to cart
		fetch(`${Shopify.routes.root}cart.js`)
			.then((response) => response.json())
			.then((cart) => {
				console.log('Cart:', cart);
				const changedItems = cart.items.map((lineItem) => {
					return {
						id: lineItem.variant_id,
						quantity: lineItem.quantity,
						properties: {},
					};
				});
				document.cookie = 'cart=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
				changedItems.forEach((lineItem) => {
					fetch(`${Shopify.routes.root}cart/add.js`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify(lineItem),
					}).then(async (response) => {
						const responseJson = await response.json();
						if (response.ok) {
							document.dispatchEvent(
								new CustomEvent('cart:refresh', {
									detail: {
										cart: responseJson,
									},
								}),
							);
						}
					});
				});
			});
		//
		// document.cookie = "cart=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
	}

	disconnectedCallback() {
		//
		this.applyDiscountsBtn.removeEventListener('click', this.applyDiscounts);
	}
}

// Path: assets/cart.js
// Check if custom element is exists if not add it
if (!window.customElements.get('cart-discounts-applier')) {
	window.customElements.define('cart-discounts-applier', cartDiscountsApplier);
}

class totalPrice extends HTMLElement {
	constructor() {
		super();
	}
	connectedCallback() {
		document.addEventListener('discounts:apply', this.updateTotalPrice.bind(this));
		document.addEventListener('cart:updated', this.updateTotalPrice.bind(this));
		this.paragraphElement = this.querySelector('p');
	}

	updateTotalPrice(event) {
		// Update total price
		this.discountCode = '';
		if (event && event.detail && event.detail.discountCode) {
			this.discountCode = event.detail.discountCode;
		}
		fetch(`${Shopify.routes.root}cart.js`)
			.then((response) => response.json())
			.then((cart) => {
				const totalPrice = cart.total_price / 100;
				const discountCodes = cart.discount_codes || [];
				discountCodes.forEach((discountCode) => {
					if (discountCode.code === this.discountCode) {
						// Apply discount to total price
						document.dispatchEvent(new CustomEvent('discounts:showMessage', {
							detail: {
								isSuccess: discountCode.applicable,
							},
						}));
					}
				});
				const money = new Intl.NumberFormat('de-DE', { style: 'currency', currency: cart.currency }).format(totalPrice);
				const moneyWithLastSymbolAtStart = money.slice(-1) + money.slice(0, -1);
				this.paragraphElement.innerHTML = moneyWithLastSymbolAtStart.slice(0, -1) + ' ' + cart.currency;
			});
	}
}

if (!window.customElements.get('total-price')) {
	window.customElements.define('total-price', totalPrice);
}
